import locale from "../../lib/locales/fr.json";
window.I18nlocales = window.I18nlocales || [];
window.I18nlocales.push(locale);